import { Box, ListItem, styled } from '@mui/material';

export const TriggerContainer = styled(Box)<{ isOpen?: boolean }>(
  ({ theme, isOpen }) => ({
    position: 'relative',
    ...(isOpen && {
      zIndex: theme.zIndex.modal,
      '&:before': {
        content: '""',
        position: 'fixed',
        zIndex: theme.zIndex.modal - 1,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      }
    })
  })
);

export const EntitySearchContainer = styled(Box)<{
  minWidth?: string | number;
}>(({ theme, minWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: minWidth || '400px',
  backgroundColor: theme.palette.common.white,
  '&:not(.inline)': {
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.vars.palette.outline.variant}`,
    boxShadow: theme.vars.shadows[4]
  }
}));

export const EntitySearchPaper = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['anchorEl', 'disablePortal'].includes(prop)
})({
  boxShadow: 'none'
});

export const EntitySearchListItem = styled(ListItem, {
  shouldForwardProp: (propName) => propName !== 'disabled'
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  ...(disabled && {
    pointerEvents: 'none'
  }),
  '&.MuiAutocomplete-option': {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2, 4),
    paddingRight: theme.spacing(2)
  }
}));
